import {useState,useEffect,useRef,useContext, useImperativeHandle, forwardRef} from "react";
import { Configurations, otherConfigOptionsAttributes, otherConfigOptionsAttributesFeature } from "../configSetupScreen/widget/configBottomBar";
import ReloadButton from "../uiThemeConfig/widgets/reloadButton";
import {
  TransformedConfig,
  configurationAttributeType,
  projectConfigurationValuesTypes,
} from "../../../../types";
import * as Sentry from "@sentry/react";
import {
  PlaygroundConfigValueContext,
} from "../../../../components/newPortal/NewPortalLayout";
import {
  FeatureSelectionOptionsContext,
} from "../../../settings/components/FeatureSelectionOptionsContext";
import { objectKeys } from "../../../../utils/utils";
import { openPopup as triggerPopUp } from "../../../../stateManagement/actions/popupActions";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import { metaDataBatchPayload, popupType } from "../../../../types/types";
import {
  convertValuesToConfigNew,
  createValidation,
  doFinalConfigSubmit,
  fetchMultipleUIConfigData,
  fetchUIConfigData,
  getNewConfiguration,
  getStudioConfigMap,
  validateMetaDataResponse,
} from "../../../../services/uiConfigService";
import ConfigWrapper from "../optionalFeatures/widget/ConfigWrapper";
import ConfigButtons from '../components/configButtons';
import ConfigHeading from '../components/configHeading';
import ResetButton from "../../../../components/resetButton/ResetButton";
import { Loader } from "../../../../components/loader/Loader";
import { usePopup } from "../../../../components/newPortal/PopUpContext";
import { StudioRoleSelectionAndSavePopupModal } from "../../../../components/newPortal/components/studioRoleSelectionAndSavePopupModal";
import { useSelector } from "react-redux";
import store from "../../../../stateManagement/store";
import { OptionType } from '../../../manageHomepage/ManageHomePageTypes';
import { Box, Typography } from "@mui/material";
import { GenericUIComponentNew } from "../../../../components/uiConfig/GenericUiComponentNew";
import { mapUiSchemaToType } from "../optionalFeatures/OptionalFeatureLayout";
import CustomComponentMapping from "./CustomComponentMapping";



interface Props{
  subFeature?:otherConfigOptionsAttributesFeature;
  areDataFieldsValid:boolean,
  setAreDataFieldsValid:(isValid: boolean) => void;
}

const GenericComponentConfig =forwardRef((props:Props,ref)=>{
     const [values, setValues] = useState<any>( {} );
     const [values2, setValues2] = useState<any>( {} );
     const [defaultValues, setDefaultValues] = useState<any>( {} );
     const [isSpinning, setIsSpinning] = useState(false);
     const [valueArray,setValueArray]=useState<any[]>([])
     const [openGenericModal, setOpenGenericModal] = useState(false);
     const [popupType, setPopupType] = useState<popupType>("Alert");
     const [genericMessage, setGenericMessage] = useState("");
    //  const [validationFailiure, setValidationFailiure] = useState<boolean>(false);
     const { showPopup } = usePopup();
     const initialConfigMap = useRef<Record<string, any>>({});
     const savedRole: any = useSelector(() => store.getState().roleState.role);
     const [loading, setLoading] = useState(true);
     const savedAppType:any = useSelector(() => store.getState().appTypeState.appType)
     const [hasActiveChild, setHasActiveChild] = useState(true);
    const PlaygroundConfigContext = useContext(PlaygroundConfigValueContext);
    const openPopup = (message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  };
    const domainMapping=props.subFeature?.domainMapping??{}
    const {
    playgroundConfiguration,
    setPlayGroundConfiguration,
    onTriggerConfigChanges,
    keyValue,
    setKeyValue,
  } = PlaygroundConfigContext ?? {
    playgroundConfiguration: [],
    setPlayGroundConfiguration: () => { },
    onTriggerConfigChanges: () => { },
    setKeyValue: () => { },
    keyValue: 0,
  };
  
  
       const init = async () => {
              try {
                  setLoading(true);      
                  const studioConfigMap = await getStudioConfigMap(domainMapping);
                  initialConfigMap.current = studioConfigMap;
                  setupConfigState(savedRole); 
              } catch (error) {
                  console.error("Error in fetching the config", error);
                  triggerPopUp("Error", "Error in fetching the config", () => { });
              } finally {
                  setLoading(false);
              }
          }
          const setupConfigState = (role : OptionType) => {
              if(!initialConfigMap.current){
                return;
              }
              let totalArray:any[]=[];
            for(let key in domainMapping){
                for(let objectkey in domainMapping[key]){
                const appConfig = initialConfigMap.current[key]?.find((config: any) => config?.domainType === `${role.id}_${domainMapping[key][objectkey]}`) ?? {};
                const tempAppConfigArray = appConfig?.["domainValues"] ?? []
               const appConfigArray = tempAppConfigArray.map((item: any) => {
  item.domainType = domainMapping[key][objectkey];
  return item;
});
              const newAppConfigValue = structuredClone(defaultValues);
              for (const key in newAppConfigValue) {
                if (newAppConfigValue?.hasOwnProperty(key)) {
                  const matchingConfig = appConfigArray.find((cfg: Record<string, any>) => cfg.name === key);
                  if (matchingConfig) {
                    newAppConfigValue[key].value = matchingConfig?.value;
                  }
                }
              }
              totalArray=[...totalArray,...appConfigArray]
             }
            } 
            const obj = totalArray.reduce((acc:any, item:any) => {
            acc[item.name] = item;
            return acc;
          }, {});

  setValues((prev:any)=>({...prev,...obj})) 
         }
         const handlePreview = async () => {
             // if (!areDataFieldsValid)
             //   return;
             try {
               setIsSpinning(true);
               const convertedVals: configurationAttributeType[] = await getConvertedVals() ?? [];
               setPlayGroundConfiguration(convertedVals);
              
               const res: any = await doFinalConfigSubmit(
                 "playground_config",
                 convertedVals
               );
               if (res["status"] === 200) {
                 setKeyValue(keyValue + 1);
               }
             } catch (error) {
               console.error("Error in onTriggerConfigChanges:", error);
             }
             setTimeout(() => {
               setIsSpinning(false);
             }, 1000);
           }
           useImperativeHandle(ref,()=>({
            handlePreview,
           })
           )
             const getConvertedVals = async ({ eventTriggeredByPreview }: { eventTriggeredByPreview?: boolean } = { eventTriggeredByPreview: false }) => {
               try {
                 const mainValue: configurationAttributeType[] = Object.values(values);
                 const resultantValues = { ...values };
                 const {
                   result,
                   failedValidations,
                   missingFromGlobal,
                 } = convertValuesToConfigNew(resultantValues, mainValue, values);
                 if (missingFromGlobal.length > 0) {
                   const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(
                     ", "
                   )}`;
                   triggerPopUp(
                     "Error",
                     `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`
                   );
                   if (eventTriggeredByPreview) setIsSpinning(false);
                   return;
                 }
                 if (failedValidations.length > 0) {
                   const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(
                     ", "
                   )}`;
                   triggerPopUp(
                     "Error",
                     `Some errors occurred while saving data.\n\n${failedKeysMessage}`
                   );
                   if (eventTriggeredByPreview) setIsSpinning(false);
                   return;
                 }
                 return result;
               } catch (error) {
                 throw Error("error in saving")
               }
             }
           const handleSave = async (preview?: boolean) => {
             try {
              
               const resultantValues = { ...values };
               const { result: convertedVals, failedValidations: failedValidations, missingFromGlobal: missingFromGlobal } = convertValuesToConfigNew(
                 resultantValues,
                 Object.values(values),
                 defaultValues
               );
               if (missingFromGlobal.length > 0) {
                 const missingFromGlobalMsg = `The following configurations are not present in global configuration: ${missingFromGlobal.join(", ")}`;
                 triggerPopUp("Error", `Some errors occurred while saving data.\n\n${missingFromGlobalMsg}`);
                 return;
               }
               if (failedValidations.length > 0) {
                 const failedKeysMessage = `The following configurations failed validation: ${failedValidations.join(", ")}`;
                 triggerPopUp("Error", `Some errors occurred while saving data.\n\n${failedKeysMessage}`);
                 return;
               }
               
              
               
               const updatedConfigMap: Record<string, any> = structuredClone(initialConfigMap.current);
                for(let key in domainMapping){
                for(let objectkey in domainMapping[key]){
                
               const configList = updatedConfigMap?.[key];
              
               if (Array.isArray(configList)) {
                 const Obj = configList.find(
                   (obj: any) => obj?.domainType === `${savedRole.id}_${domainMapping[key][objectkey]}`
                 );
                const domainSpecificConvertedVals=convertedVals.filter((item)=>item.domainType===domainMapping[key][objectkey])
                 if (Obj) {
                   Obj.domainValues = domainSpecificConvertedVals
                 }
                 else
                 {
                   configList.push({
                     domainType: `${savedRole.id}_${domainMapping[key][objectkey]}`,
                     domainValues:domainSpecificConvertedVals
                   });
                 }
               }
            }}
        
               
               showPopup((close) => (
                         <StudioRoleSelectionAndSavePopupModal
                           inputData={{
                             requiredConfigsMap : domainMapping,
                             initialConfigMap : initialConfigMap.current,
                             updatedConfigMap : updatedConfigMap,
                             appType : savedAppType,
                             role : savedRole,
                           }}
                           onCancel = {close}
                           actionPostSuccess = {init}
                         />
                       ));
             } catch (err) {
               Sentry.captureException(err);
               console.log("err===", err);
               if (err instanceof Error)
                 openPopup("Validation Error occured : " + err?.message, "Error");
             }
           };
        const handleReset=()=>{
            init();
        }
        

     useEffect(() => {
     
        const fetchData = async () => {
          try {
            const stringMap:string[]=[];
            for(let key in domainMapping){
                for(let objectkey in domainMapping[key]){
                    stringMap.push(domainMapping[key][objectkey])
                }}
              
            await fetchMultipleUIConfigData(setValues2,setDefaultValues,stringMap,setLoading);
            // console.error("Error fetching data:", error);
          } finally {
            setLoading(false);
          }
        };
        fetchData();
      }, []);
    
      useEffect(() => {
          setHasActiveChild(!!localStorage.getItem("activeChild"));
        }, []);
         useEffect(() => {
     if (Object.keys(defaultValues).length !== 0)
        init();
      }, [defaultValues])
  
    useEffect(() => {
        setupConfigState(savedRole);
      }, [savedRole])
      useEffect(()=>{
        setValueArray(Object.values(values))
      
      },[values])
      
         return (
        <div className=" config-container-left">
            {/* <ConfigHeading handleReset={handleReset} featureId={props.subFeature?.id??""} featureName={props.subFeature?.id??""} /> */}

            <div className="config-main-logic-container">
                {loading||valueArray.length===0  ? (
                 
                   <Loader />

                   
                ) : (
                    <div className="config-main">
                       
                            

 
    {Object.entries(
      props?.subFeature?.configuration?.reduce((acc: Record<string, Configurations[]> , item: Configurations) => {
        const section = item.section || "General";
        acc[section] = acc[section] || [];
        acc[section].push(item);
        return acc;
      }, {})??{}
    ).map(([sectionName, items]) => (
      <div key={sectionName} style={{textAlign:"left"}}>
        <div style={{backgroundColor:'#F5F5F7', padding:"12px", fontSize:"12px", marginBottom:"2px"}}>
        <Typography  sx={{  fontWeight: "600",
         }}>
          {sectionName}
        </Typography>
        </div>
        <div style={{margin:"12px 16px 12px 12px"}} >
        {items.map((item: any) => {
          const matched = valueArray.find((val: any) => val.name === item.name);
          if (!matched || item.uiSchema.config === "custom") {
            const Comp = CustomComponentMapping({
              values,
              setValues,
              name: `${props?.subFeature?.id.replace(/\s+/g, "").toLowerCase()}_${item.name.replace(/\s+/g, "").toLowerCase()}`,
              extraAttributes: { savedRole },
            });
            return Comp && (
              <div style={{padding:"8px",borderRadius:"8px",backgroundColor:"#f8fafc",marginBottom:"10px"}}>{Comp}</div>
            ) 
          }
            if (item.uiSchema?.dependsOn) {
        const dependancy=item.uiSchema?.dependsOn;
        for(let field in dependancy){
          if(values?.[field]?.value!==dependancy[field]){
            return null;
          }
        }
      }

          return (
            <GenericUIComponentNew
              key={matched.name}
              sx={{ minWidth: "50%", borderRadius: "8px", padding:"8px",marginBottom:"10px",backgroundColor:"#f8fafc" ,display:item.uiSchema.displayType==="toggle"?"flex":undefined, justifyContent:"space-between", alignItems:"center",}}
              heading={item.uiSchema.question}
              type={mapUiSchemaToType(item.uiSchema.displayType?.toLowerCase() ?? "")}
              values={values}
              setValues={setValues}
              name={matched.name}
              validations={item?.uiSchema?.validations ?? {}}
              setAreDataFieldsValid={props.setAreDataFieldsValid}
            />
          );
        })}
        </div>
      </div>
    ))}


                      
                    </div>
                )}
{(!loading&&valueArray.length>0)&&
                <ConfigButtons
                    areDataFieldsValid={props.areDataFieldsValid}
                    hasActiveChild={hasActiveChild}
                    handleSave={handleSave}
                    handleReset={handleReset}
                    isSpinning={isSpinning}
                    setIsSpinning={setIsSpinning}
                />
}
            </div>
        </div>
    );
    


})
export default GenericComponentConfig